import { all, fork } from 'redux-saga/effects'

import gameSaga from './gameSaga'

export function* rootSaga() {
  yield all([fork(gameSaga)])
}
